import { isStorePreferencesConfig } from '@repo/types/store-preferences';
import { fetcher } from '@repo/utils';

export const getStorePreferences = async (basePath: string, countryCode: string, buCode: string) => {
    const url = `${basePath}/${countryCode}/${buCode}`;
    const req = await fetcher(url);
    const data = await req.json();

    return isStorePreferencesConfig(data) ? data : Promise.reject(new Error());
};
